<script setup lang="ts">
import { BannerDeliveryPaymentsProps } from "./BannerDeliveryPayments.props"

withDefaults(defineProps<BannerDeliveryPaymentsProps>(), {
  backgroundColor: "tiffany-10"
})
</script>

<template>
  <div v-if="banners?.length" class="organisms-banner_delivery_payments">
    <div
      class="md:my-6 md:grid md:grid-cols-2 md:overflow-hidden md:rounded-lg"
    >
      <BannerDeliveryPayment
        v-for="(banner, index) in banners"
        v-bind="banner"
        :background-color="backgroundColor"
        :key="index"
        :class="{
          'md:rounded-lg': banners?.length === 1,
          'col-span-full': isOneBannerFull
        }"
      />
    </div>
  </div>
</template>
